import type { BundleDetailDto, BundleDto } from "../../models/models"
import {
  createNewBundle,
  getBundle,
  getBundleList,
  removeBundle,
  searchBundles,
  updateExistingBundle
} from "../../services/BundleService"
import { bundleDtoToBundle, fetchBosatlas } from "../bosatlas/bosatlas.actions"
import type { AppThunkAction, AppThunkDispatch } from "./../app.types"
import type { BundleAction, BundlesAction } from "./bundles.types"

export const BUNDLE_FETCH_LIST: string = "BUNDLE_FETCH_LIST"
export const BUNDLE_LOAD_LIST: string = "BUNDLES_LOAD_LIST"

export const BUNDLE_FETCH: string = "BUNDLE_FETCH"
export const BUNDLE_LOAD: string = "BUNDLE_LOAD"
export const BUNDLE_CREATE: string = "BUNDLE_CREATE"
export const BUNDLE_CREATE_COMPLETED: string = "BUNDLE_CREATE_COMPLETED"

export const BUNDLE_DELETE: string = "BUNDLE_DELETE"
export const BUNDLE_DELETE_COMPLETE: string = "BUNDLE_DELETE_COMPLETE"
export const BUNDLE_UPDATE: string = "BUNDLE_UPDATE"
export const BUNDLE_SEARCH: string = "BUNDLE_SEARCH"

export function fetchBundle(bundleId: string): AppThunkAction<void, BundleAction> {
  return async (dispatch: AppThunkDispatch<BundleAction>) => {
    dispatch({ type: BUNDLE_FETCH })
    const bundle: BundleDetailDto = await getBundle(bundleId)
    dispatch(loadBundle(bundle))
  }
}

export function bundleLoadList(bundles: BundleDto[]): BundlesAction {
  return { type: BUNDLE_LOAD_LIST, payload: bundles.map(bundleDtoToBundle) }
}

export function loadBundle(bundle: BundleDetailDto): BundleAction {
  return {
    type: BUNDLE_LOAD,
    payload: bundle
  }
}

export function createBundle(title: string): AppThunkAction<void, BundleAction> {
  return async (dispatch: AppThunkDispatch<BundleAction>) => {
    dispatch({ type: BUNDLE_CREATE })

    await createNewBundle(title)

    dispatch({ type: BUNDLE_CREATE_COMPLETED })
    dispatch(fetchBosatlas())
  }
}

export function bundleSearch(searchValue: string): AppThunkAction<void, BundlesAction> {
  return async (dispatch: AppThunkDispatch<BundlesAction>) => {
    const bundles: BundleDto[] = searchValue.length ? await searchBundles(searchValue) : await getBundleList()

    dispatch(bundleLoadList(bundles))
  }
}

export function createBundleCompleted(bundle: BundleDto): BundleAction {
  return {
    type: BUNDLE_CREATE_COMPLETED,
    payload: bundle
  }
}

export function deleteBundle(bundle: BundleDetailDto): AppThunkAction<void, BundleAction> {
  return async (dispatch: AppThunkDispatch<BundleAction>) => {
    dispatch({ type: BUNDLE_DELETE })

    await removeBundle(bundle.id)

    dispatch(deleteBundleCompleted(bundle))

    dispatch(fetchBosatlas())
  }
}

export function deleteBundleCompleted(bundle: BundleDetailDto): BundleAction {
  return {
    type: BUNDLE_DELETE_COMPLETE,
    payload: bundle
  }
}

export function updateBundle(id: string, title: string): AppThunkAction<void, BundleAction> {
  return async (dispatch: AppThunkDispatch<BundleAction>) => {
    dispatch({ type: BUNDLE_UPDATE })

    await updateExistingBundle(id, title)
  }
}
